import { MouseEvent, MouseEventHandler } from "react";

import { useGetLinkComponentAndProps } from "../../../hooks/link";
import { LocationShape, Path } from "../../../types";
import { Icon } from "../../content";
import { Center } from "../../layout";
import { sizeMap, useGetIconButtonStyles } from "../IconButton";
import { IconButtonProps } from "../IconButton/IconButton";

type Props = Omit<IconButtonProps, "onClick"> & {
  to: string | LocationShape | Path;
  onClick?: MouseEventHandler;
  newTab?: boolean;
  replace?: boolean;
  state?: any;
};

export default function IconButtonLink({
  iconName,
  onClick,
  size = "large",
  to,
  newTab,
  tone = "primary",
  disabled = false,
  replace,
  blend = false,
  accessibilityLabel,
  state,
  fill = "filledTonal"
}: Props) {
  const styleProps = useGetIconButtonStyles({
    tone,
    disabled,
    blend,
    size,
    fill
  });

  const { Component, linkProps } = useGetLinkComponentAndProps({
    to,
    disabled,
    newTab,
    replace,
    state
  });

  const { iconSize } = sizeMap[size];

  return (
    <Component
      onClick={(e: MouseEvent) => {
        !disabled && onClick && onClick(e);
      }}
      aria-label={accessibilityLabel}
      disabled={disabled}
      {...styleProps}
      {...linkProps}
    >
      <Center>
        <Icon accessibilityLabel={null} iconName={iconName} size={iconSize} />
      </Center>
    </Component>
  );
}
